module.exports = __webpack_public_path__ + "static/media/msteams.85f2df3e.webp";